import React, { FC, ReactNode } from 'react'
import S from './Label.styles'

interface LabelProps {
  htmlFor?: string
  children: ReactNode
}

const Label: FC<LabelProps> = ({ htmlFor = '', children }) => {
  return <S.Label htmlFor={htmlFor}>{children}</S.Label>
}

export default Label
